"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertParamsToQuery = void 0;
const convertParamsToQuery = (params) => {
    const query = {};
    if (params.types) {
        query.types = typeof params.types === 'string' ? params.types : `${params.types.join(',')}`;
    }
    if (params.name) {
        query.ric = params.name;
    }
    if (params.version) {
        query.version = params.version;
    }
    if (!params.version) {
        query.version = 'v2';
    }
    return query;
};
exports.convertParamsToQuery = convertParamsToQuery;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy9tZXRhZGF0YS9oZWxwZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVPLE1BQU0sb0JBQW9CLEdBQUcsQ0FJaEMsTUFBZSxFQUNQLEVBQUU7SUFDVixNQUFNLEtBQUssR0FBdUMsRUFBRSxDQUFDO0lBRXJELElBQUksTUFBTSxDQUFDLEtBQUssRUFBRSxDQUFDO1FBQ2YsS0FBSyxDQUFDLEtBQUssR0FBRyxPQUFPLE1BQU0sQ0FBQyxLQUFLLEtBQUssUUFBUSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUM7SUFDaEcsQ0FBQztJQUVELElBQUksTUFBTSxDQUFDLElBQUksRUFBRSxDQUFDO1FBQ2QsS0FBSyxDQUFDLEdBQUcsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDO0lBQzVCLENBQUM7SUFFRCxJQUFJLE1BQU0sQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUNqQixLQUFLLENBQUMsT0FBTyxHQUFHLE1BQU0sQ0FBQyxPQUFPLENBQUM7SUFDbkMsQ0FBQztJQUVELElBQUksQ0FBQyxNQUFNLENBQUMsT0FBTyxFQUFFLENBQUM7UUFDbEIsS0FBSyxDQUFDLE9BQU8sR0FBRyxJQUFJLENBQUM7SUFDekIsQ0FBQztJQUVELE9BQU8sS0FBaUIsQ0FBQztBQUM3QixDQUFDLENBQUM7QUF6QlcsUUFBQSxvQkFBb0Isd0JBeUIvQiJ9